var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaackLogoNegative(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 159,
    height: 45.161,
    viewBox: "0 0 159 45.161",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-new_logo_code"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 159,
    height: 45.161
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "new_logo_code",
    clipPath: "url(#clip-new_logo_code)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-4",
    "data-name": "Trazado 1",
    d: "M321.119,1637.711a9.6,9.6,0,0,0-8.129,9.6v14.381h3.652V1654.5a9.431,9.431,0,1,0,4.478-16.789m2.626,14.975a5.785,5.785,0,1,1,4.308-4.307,5.793,5.793,0,0,1-4.308,4.307",
    transform: "translate(-253.886 -1625.009)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-9",
    "data-name": "Trazado 2",
    d: "M520.523,1656.482a9.433,9.433,0,1,1,6.668-16.1l-2.582,2.582a5.78,5.78,0,1,0,0,8.173l2.582,2.584a9.371,9.371,0,0,1-6.668,2.762",
    transform: "translate(-388.863 -1625.004)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-11",
    "data-name": "Trazado 3",
    d: "M389.755,1637.715a9.434,9.434,0,1,0,4.478,16.789v1.6h3.653v-8.788a9.6,9.6,0,0,0-8.131-9.6m.022,14.975a5.785,5.785,0,1,1,4.309-4.308,5.794,5.794,0,0,1-4.309,4.308",
    transform: "translate(-298.877 -1625.012)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-13",
    "data-name": "Trazado 4",
    d: "M455.792,1637.711a9.434,9.434,0,1,0,4.477,16.789v1.6h3.653v-8.786a9.6,9.6,0,0,0-8.131-9.6m.023,14.975a5.785,5.785,0,1,1,4.308-4.309,5.793,5.793,0,0,1-4.308,4.309",
    transform: "translate(-343.873 -1625.009)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-13",
    "data-name": "Trazado 5",
    d: "M577.514,1636.521l6.879-6.551h-5.3l-7.23,6.883v-12.248h-3.652v22.726h3.652V1641.9l2.986-2.844,6.342,8.279h4.6Z",
    transform: "translate(-427.786 -1616.138)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-13",
    "data-name": "Trazado 6",
    d: "M127.5,1679.557l8.325-4.806a9.42,9.42,0,0,1,9.42,0l8.325,4.806-8.325,4.806a9.417,9.417,0,0,1-9.42,0Z",
    transform: "translate(-127.499 -1649.446)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-13",
    "data-name": "Trazado 7",
    d: "M209.315,1632.316l8.325-4.806a9.417,9.417,0,0,1,9.421,0l8.325,4.806-8.325,4.806a9.417,9.417,0,0,1-9.421,0Z",
    transform: "translate(-183.245 -1617.257)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-13",
    "data-name": "Trazado 8",
    d: "M209.314,1691.49v-9.612a9.423,9.423,0,0,1,4.711-8.157l8.325-4.806v9.612a9.427,9.427,0,0,1-4.711,8.159Z",
    transform: "translate(-183.244 -1646.328)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-13",
    "data-name": "Trazado 9",
    d: "M168.364,1620.608v-9.614a9.422,9.422,0,0,1,4.711-8.158l8.325-4.806v9.613a9.419,9.419,0,0,1-4.71,8.157Z",
    transform: "translate(-155.343 -1598.031)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaackLogoNegative);
export default __webpack_public_path__ + "static/media/paack-logo-negative.163a760e96a58f642caa58c74726cd55.svg";
export { ForwardRef as ReactComponent };